/**
 * Generated by orval v8.20.0 🍺
 * Do not edit manually.
 * Smart Sash Admin API
 * RESTful API for Smart Sash device management, user authentication, and system administration
 * OpenAPI spec version: 0.13.0.0
 */
import {
  useInfiniteQuery,
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseInfiniteQueryResult,
  DefinedUseQueryResult,
  InfiniteData,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseInfiniteQueryOptions,
  UseInfiniteQueryResult,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  DeviceCreateUpdateDTO,
  DeviceModeResponse,
  DeviceMoveRequest,
  DeviceViewDTO,
  DeviceViewDTOPaginationResult,
  EmergencyContactDTO,
  GetApiDeviceParams,
  ProblemDetails,
  SetDeviceModeRequest
} from '../../models';

import { customInstance } from '../../../http/customInstance';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

export const getApiDevice = (
    params?: GetApiDeviceParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<DeviceViewDTOPaginationResult>(
      {url: `/api/Device`, method: 'GET',
        params, signal
    },
      options);
    }




export const getGetApiDeviceInfiniteQueryKey = (params?: GetApiDeviceParams,) => {
    return [
    'infinite', `/api/Device`, ...(params ? [params] : [])
    ] as const;
    }

export const getGetApiDeviceQueryKey = (params?: GetApiDeviceParams,) => {
    return [
    `/api/Device`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetApiDeviceInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof getApiDevice>>>, TError = ProblemDetails>(params?: GetApiDeviceParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getApiDevice>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiDeviceInfiniteQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiDevice>>> = ({ signal }) => getApiDevice(params, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof getApiDevice>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetApiDeviceInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof getApiDevice>>>
export type GetApiDeviceInfiniteQueryError = ProblemDetails


export function useGetApiDeviceInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getApiDevice>>>, TError = ProblemDetails>(
 params: undefined |  GetApiDeviceParams, options: { query:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getApiDevice>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiDevice>>,
          TError,
          Awaited<ReturnType<typeof getApiDevice>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiDeviceInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getApiDevice>>>, TError = ProblemDetails>(
 params?: GetApiDeviceParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getApiDevice>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiDevice>>,
          TError,
          Awaited<ReturnType<typeof getApiDevice>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiDeviceInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getApiDevice>>>, TError = ProblemDetails>(
 params?: GetApiDeviceParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getApiDevice>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetApiDeviceInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getApiDevice>>>, TError = ProblemDetails>(
 params?: GetApiDeviceParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getApiDevice>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetApiDeviceInfiniteQueryOptions(params,options)

  const query = useInfiniteQuery(queryOptions, queryClient) as  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getGetApiDeviceQueryOptions = <TData = Awaited<ReturnType<typeof getApiDevice>>, TError = ProblemDetails>(params?: GetApiDeviceParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiDevice>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiDeviceQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiDevice>>> = ({ signal }) => getApiDevice(params, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiDevice>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetApiDeviceQueryResult = NonNullable<Awaited<ReturnType<typeof getApiDevice>>>
export type GetApiDeviceQueryError = ProblemDetails


export function useGetApiDevice<TData = Awaited<ReturnType<typeof getApiDevice>>, TError = ProblemDetails>(
 params: undefined |  GetApiDeviceParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiDevice>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiDevice>>,
          TError,
          Awaited<ReturnType<typeof getApiDevice>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiDevice<TData = Awaited<ReturnType<typeof getApiDevice>>, TError = ProblemDetails>(
 params?: GetApiDeviceParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiDevice>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiDevice>>,
          TError,
          Awaited<ReturnType<typeof getApiDevice>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiDevice<TData = Awaited<ReturnType<typeof getApiDevice>>, TError = ProblemDetails>(
 params?: GetApiDeviceParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiDevice>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetApiDevice<TData = Awaited<ReturnType<typeof getApiDevice>>, TError = ProblemDetails>(
 params?: GetApiDeviceParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiDevice>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetApiDeviceQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const postApiDevice = (
    deviceCreateUpdateDTO?: DeviceCreateUpdateDTO,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<DeviceViewDTO>(
      {url: `/api/Device`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: deviceCreateUpdateDTO, signal
    },
      options);
    }




export const getPostApiDeviceMutationOptions = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiDevice>>, TError,{data?: DeviceCreateUpdateDTO}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof postApiDevice>>, TError,{data?: DeviceCreateUpdateDTO}, TContext> => {

const mutationKey = ['postApiDevice'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postApiDevice>>, {data?: DeviceCreateUpdateDTO}> = (props) => {
          const {data} = props ?? {};

          return  postApiDevice(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PostApiDeviceMutationResult = NonNullable<Awaited<ReturnType<typeof postApiDevice>>>
    export type PostApiDeviceMutationBody = DeviceCreateUpdateDTO | undefined
    export type PostApiDeviceMutationError = ProblemDetails

    export const usePostApiDevice = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiDevice>>, TError,{data?: DeviceCreateUpdateDTO}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postApiDevice>>,
        TError,
        {data?: DeviceCreateUpdateDTO},
        TContext
      > => {
      return useMutation(getPostApiDeviceMutationOptions(options), queryClient);
    }
    export const getApiDeviceSerialSerialNumber = (
    serialNumber: string,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<DeviceViewDTO>(
      {url: `/api/Device/serial/${serialNumber}`, method: 'GET', signal
    },
      options);
    }




export const getGetApiDeviceSerialSerialNumberInfiniteQueryKey = (serialNumber: string,) => {
    return [
    'infinite', `/api/Device/serial/${serialNumber}`
    ] as const;
    }

export const getGetApiDeviceSerialSerialNumberQueryKey = (serialNumber: string,) => {
    return [
    `/api/Device/serial/${serialNumber}`
    ] as const;
    }


export const getGetApiDeviceSerialSerialNumberInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof getApiDeviceSerialSerialNumber>>>, TError = ProblemDetails>(serialNumber: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getApiDeviceSerialSerialNumber>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiDeviceSerialSerialNumberInfiniteQueryKey(serialNumber);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiDeviceSerialSerialNumber>>> = ({ signal }) => getApiDeviceSerialSerialNumber(serialNumber, requestOptions, signal);





   return  { queryKey, queryFn, enabled: serialNumber !== null && serialNumber !== undefined, ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof getApiDeviceSerialSerialNumber>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetApiDeviceSerialSerialNumberInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof getApiDeviceSerialSerialNumber>>>
export type GetApiDeviceSerialSerialNumberInfiniteQueryError = ProblemDetails


export function useGetApiDeviceSerialSerialNumberInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getApiDeviceSerialSerialNumber>>>, TError = ProblemDetails>(
 serialNumber: string, options: { query:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getApiDeviceSerialSerialNumber>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiDeviceSerialSerialNumber>>,
          TError,
          Awaited<ReturnType<typeof getApiDeviceSerialSerialNumber>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiDeviceSerialSerialNumberInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getApiDeviceSerialSerialNumber>>>, TError = ProblemDetails>(
 serialNumber: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getApiDeviceSerialSerialNumber>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiDeviceSerialSerialNumber>>,
          TError,
          Awaited<ReturnType<typeof getApiDeviceSerialSerialNumber>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiDeviceSerialSerialNumberInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getApiDeviceSerialSerialNumber>>>, TError = ProblemDetails>(
 serialNumber: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getApiDeviceSerialSerialNumber>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetApiDeviceSerialSerialNumberInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getApiDeviceSerialSerialNumber>>>, TError = ProblemDetails>(
 serialNumber: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getApiDeviceSerialSerialNumber>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetApiDeviceSerialSerialNumberInfiniteQueryOptions(serialNumber,options)

  const query = useInfiniteQuery(queryOptions, queryClient) as  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getGetApiDeviceSerialSerialNumberQueryOptions = <TData = Awaited<ReturnType<typeof getApiDeviceSerialSerialNumber>>, TError = ProblemDetails>(serialNumber: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiDeviceSerialSerialNumber>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiDeviceSerialSerialNumberQueryKey(serialNumber);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiDeviceSerialSerialNumber>>> = ({ signal }) => getApiDeviceSerialSerialNumber(serialNumber, requestOptions, signal);





   return  { queryKey, queryFn, enabled: serialNumber !== null && serialNumber !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiDeviceSerialSerialNumber>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetApiDeviceSerialSerialNumberQueryResult = NonNullable<Awaited<ReturnType<typeof getApiDeviceSerialSerialNumber>>>
export type GetApiDeviceSerialSerialNumberQueryError = ProblemDetails


export function useGetApiDeviceSerialSerialNumber<TData = Awaited<ReturnType<typeof getApiDeviceSerialSerialNumber>>, TError = ProblemDetails>(
 serialNumber: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiDeviceSerialSerialNumber>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiDeviceSerialSerialNumber>>,
          TError,
          Awaited<ReturnType<typeof getApiDeviceSerialSerialNumber>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiDeviceSerialSerialNumber<TData = Awaited<ReturnType<typeof getApiDeviceSerialSerialNumber>>, TError = ProblemDetails>(
 serialNumber: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiDeviceSerialSerialNumber>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiDeviceSerialSerialNumber>>,
          TError,
          Awaited<ReturnType<typeof getApiDeviceSerialSerialNumber>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiDeviceSerialSerialNumber<TData = Awaited<ReturnType<typeof getApiDeviceSerialSerialNumber>>, TError = ProblemDetails>(
 serialNumber: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiDeviceSerialSerialNumber>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetApiDeviceSerialSerialNumber<TData = Awaited<ReturnType<typeof getApiDeviceSerialSerialNumber>>, TError = ProblemDetails>(
 serialNumber: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiDeviceSerialSerialNumber>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetApiDeviceSerialSerialNumberQueryOptions(serialNumber,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getApiDeviceMacMacAddress = (
    macAddress: string,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<DeviceViewDTO>(
      {url: `/api/Device/mac/${macAddress}`, method: 'GET', signal
    },
      options);
    }




export const getGetApiDeviceMacMacAddressInfiniteQueryKey = (macAddress: string,) => {
    return [
    'infinite', `/api/Device/mac/${macAddress}`
    ] as const;
    }

export const getGetApiDeviceMacMacAddressQueryKey = (macAddress: string,) => {
    return [
    `/api/Device/mac/${macAddress}`
    ] as const;
    }


export const getGetApiDeviceMacMacAddressInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof getApiDeviceMacMacAddress>>>, TError = ProblemDetails>(macAddress: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getApiDeviceMacMacAddress>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiDeviceMacMacAddressInfiniteQueryKey(macAddress);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiDeviceMacMacAddress>>> = ({ signal }) => getApiDeviceMacMacAddress(macAddress, requestOptions, signal);





   return  { queryKey, queryFn, enabled: macAddress !== null && macAddress !== undefined, ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof getApiDeviceMacMacAddress>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetApiDeviceMacMacAddressInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof getApiDeviceMacMacAddress>>>
export type GetApiDeviceMacMacAddressInfiniteQueryError = ProblemDetails


export function useGetApiDeviceMacMacAddressInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getApiDeviceMacMacAddress>>>, TError = ProblemDetails>(
 macAddress: string, options: { query:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getApiDeviceMacMacAddress>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiDeviceMacMacAddress>>,
          TError,
          Awaited<ReturnType<typeof getApiDeviceMacMacAddress>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiDeviceMacMacAddressInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getApiDeviceMacMacAddress>>>, TError = ProblemDetails>(
 macAddress: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getApiDeviceMacMacAddress>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiDeviceMacMacAddress>>,
          TError,
          Awaited<ReturnType<typeof getApiDeviceMacMacAddress>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiDeviceMacMacAddressInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getApiDeviceMacMacAddress>>>, TError = ProblemDetails>(
 macAddress: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getApiDeviceMacMacAddress>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetApiDeviceMacMacAddressInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getApiDeviceMacMacAddress>>>, TError = ProblemDetails>(
 macAddress: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getApiDeviceMacMacAddress>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetApiDeviceMacMacAddressInfiniteQueryOptions(macAddress,options)

  const query = useInfiniteQuery(queryOptions, queryClient) as  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getGetApiDeviceMacMacAddressQueryOptions = <TData = Awaited<ReturnType<typeof getApiDeviceMacMacAddress>>, TError = ProblemDetails>(macAddress: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiDeviceMacMacAddress>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiDeviceMacMacAddressQueryKey(macAddress);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiDeviceMacMacAddress>>> = ({ signal }) => getApiDeviceMacMacAddress(macAddress, requestOptions, signal);





   return  { queryKey, queryFn, enabled: macAddress !== null && macAddress !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiDeviceMacMacAddress>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetApiDeviceMacMacAddressQueryResult = NonNullable<Awaited<ReturnType<typeof getApiDeviceMacMacAddress>>>
export type GetApiDeviceMacMacAddressQueryError = ProblemDetails


export function useGetApiDeviceMacMacAddress<TData = Awaited<ReturnType<typeof getApiDeviceMacMacAddress>>, TError = ProblemDetails>(
 macAddress: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiDeviceMacMacAddress>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiDeviceMacMacAddress>>,
          TError,
          Awaited<ReturnType<typeof getApiDeviceMacMacAddress>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiDeviceMacMacAddress<TData = Awaited<ReturnType<typeof getApiDeviceMacMacAddress>>, TError = ProblemDetails>(
 macAddress: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiDeviceMacMacAddress>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiDeviceMacMacAddress>>,
          TError,
          Awaited<ReturnType<typeof getApiDeviceMacMacAddress>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiDeviceMacMacAddress<TData = Awaited<ReturnType<typeof getApiDeviceMacMacAddress>>, TError = ProblemDetails>(
 macAddress: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiDeviceMacMacAddress>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetApiDeviceMacMacAddress<TData = Awaited<ReturnType<typeof getApiDeviceMacMacAddress>>, TError = ProblemDetails>(
 macAddress: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiDeviceMacMacAddress>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetApiDeviceMacMacAddressQueryOptions(macAddress,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const putApiDeviceId = (
    id: string,
    deviceCreateUpdateDTO?: DeviceCreateUpdateDTO,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<DeviceViewDTO>(
      {url: `/api/Device/${id}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: deviceCreateUpdateDTO, signal
    },
      options);
    }




export const getPutApiDeviceIdMutationOptions = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putApiDeviceId>>, TError,{id: string;data?: DeviceCreateUpdateDTO}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof putApiDeviceId>>, TError,{id: string;data?: DeviceCreateUpdateDTO}, TContext> => {

const mutationKey = ['putApiDeviceId'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof putApiDeviceId>>, {id: string;data?: DeviceCreateUpdateDTO}> = (props) => {
          const {id,data} = props ?? {};

          return  putApiDeviceId(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PutApiDeviceIdMutationResult = NonNullable<Awaited<ReturnType<typeof putApiDeviceId>>>
    export type PutApiDeviceIdMutationBody = DeviceCreateUpdateDTO | undefined
    export type PutApiDeviceIdMutationError = ProblemDetails

    export const usePutApiDeviceId = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putApiDeviceId>>, TError,{id: string;data?: DeviceCreateUpdateDTO}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof putApiDeviceId>>,
        TError,
        {id: string;data?: DeviceCreateUpdateDTO},
        TContext
      > => {
      return useMutation(getPutApiDeviceIdMutationOptions(options), queryClient);
    }
    export const deleteApiDeviceId = (
    id: string,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<unknown | null>(
      {url: `/api/Device/${id}`, method: 'DELETE', signal
    },
      options);
    }




export const getDeleteApiDeviceIdMutationOptions = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteApiDeviceId>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteApiDeviceId>>, TError,{id: string}, TContext> => {

const mutationKey = ['deleteApiDeviceId'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteApiDeviceId>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  deleteApiDeviceId(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteApiDeviceIdMutationResult = NonNullable<Awaited<ReturnType<typeof deleteApiDeviceId>>>

    export type DeleteApiDeviceIdMutationError = ProblemDetails

    export const useDeleteApiDeviceId = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteApiDeviceId>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteApiDeviceId>>,
        TError,
        {id: string},
        TContext
      > => {
      return useMutation(getDeleteApiDeviceIdMutationOptions(options), queryClient);
    }
    export const getApiDeviceId = (
    id: string,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<DeviceViewDTO>(
      {url: `/api/Device/${id}`, method: 'GET', signal
    },
      options);
    }




export const getGetApiDeviceIdInfiniteQueryKey = (id: string,) => {
    return [
    'infinite', `/api/Device/${id}`
    ] as const;
    }

export const getGetApiDeviceIdQueryKey = (id: string,) => {
    return [
    `/api/Device/${id}`
    ] as const;
    }


export const getGetApiDeviceIdInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof getApiDeviceId>>>, TError = ProblemDetails>(id: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getApiDeviceId>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiDeviceIdInfiniteQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiDeviceId>>> = ({ signal }) => getApiDeviceId(id, requestOptions, signal);





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof getApiDeviceId>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetApiDeviceIdInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof getApiDeviceId>>>
export type GetApiDeviceIdInfiniteQueryError = ProblemDetails


export function useGetApiDeviceIdInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getApiDeviceId>>>, TError = ProblemDetails>(
 id: string, options: { query:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getApiDeviceId>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiDeviceId>>,
          TError,
          Awaited<ReturnType<typeof getApiDeviceId>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiDeviceIdInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getApiDeviceId>>>, TError = ProblemDetails>(
 id: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getApiDeviceId>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiDeviceId>>,
          TError,
          Awaited<ReturnType<typeof getApiDeviceId>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiDeviceIdInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getApiDeviceId>>>, TError = ProblemDetails>(
 id: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getApiDeviceId>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetApiDeviceIdInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getApiDeviceId>>>, TError = ProblemDetails>(
 id: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getApiDeviceId>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetApiDeviceIdInfiniteQueryOptions(id,options)

  const query = useInfiniteQuery(queryOptions, queryClient) as  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getGetApiDeviceIdQueryOptions = <TData = Awaited<ReturnType<typeof getApiDeviceId>>, TError = ProblemDetails>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiDeviceId>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiDeviceIdQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiDeviceId>>> = ({ signal }) => getApiDeviceId(id, requestOptions, signal);





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiDeviceId>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetApiDeviceIdQueryResult = NonNullable<Awaited<ReturnType<typeof getApiDeviceId>>>
export type GetApiDeviceIdQueryError = ProblemDetails


export function useGetApiDeviceId<TData = Awaited<ReturnType<typeof getApiDeviceId>>, TError = ProblemDetails>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiDeviceId>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiDeviceId>>,
          TError,
          Awaited<ReturnType<typeof getApiDeviceId>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiDeviceId<TData = Awaited<ReturnType<typeof getApiDeviceId>>, TError = ProblemDetails>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiDeviceId>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiDeviceId>>,
          TError,
          Awaited<ReturnType<typeof getApiDeviceId>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiDeviceId<TData = Awaited<ReturnType<typeof getApiDeviceId>>, TError = ProblemDetails>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiDeviceId>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetApiDeviceId<TData = Awaited<ReturnType<typeof getApiDeviceId>>, TError = ProblemDetails>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiDeviceId>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetApiDeviceIdQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const postApiDeviceIdMove = (
    id: string,
    deviceMoveRequest?: DeviceMoveRequest,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<DeviceViewDTO>(
      {url: `/api/Device/${id}/move`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: deviceMoveRequest, signal
    },
      options);
    }




export const getPostApiDeviceIdMoveMutationOptions = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiDeviceIdMove>>, TError,{id: string;data?: DeviceMoveRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof postApiDeviceIdMove>>, TError,{id: string;data?: DeviceMoveRequest}, TContext> => {

const mutationKey = ['postApiDeviceIdMove'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postApiDeviceIdMove>>, {id: string;data?: DeviceMoveRequest}> = (props) => {
          const {id,data} = props ?? {};

          return  postApiDeviceIdMove(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PostApiDeviceIdMoveMutationResult = NonNullable<Awaited<ReturnType<typeof postApiDeviceIdMove>>>
    export type PostApiDeviceIdMoveMutationBody = DeviceMoveRequest | undefined
    export type PostApiDeviceIdMoveMutationError = ProblemDetails

    export const usePostApiDeviceIdMove = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiDeviceIdMove>>, TError,{id: string;data?: DeviceMoveRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postApiDeviceIdMove>>,
        TError,
        {id: string;data?: DeviceMoveRequest},
        TContext
      > => {
      return useMutation(getPostApiDeviceIdMoveMutationOptions(options), queryClient);
    }
    export const getApiDeviceIdEmergencyContact = (
    id: string,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<EmergencyContactDTO>(
      {url: `/api/Device/${id}/emergency-contact`, method: 'GET', signal
    },
      options);
    }




export const getGetApiDeviceIdEmergencyContactInfiniteQueryKey = (id: string,) => {
    return [
    'infinite', `/api/Device/${id}/emergency-contact`
    ] as const;
    }

export const getGetApiDeviceIdEmergencyContactQueryKey = (id: string,) => {
    return [
    `/api/Device/${id}/emergency-contact`
    ] as const;
    }


export const getGetApiDeviceIdEmergencyContactInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof getApiDeviceIdEmergencyContact>>>, TError = ProblemDetails>(id: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getApiDeviceIdEmergencyContact>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiDeviceIdEmergencyContactInfiniteQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiDeviceIdEmergencyContact>>> = ({ signal }) => getApiDeviceIdEmergencyContact(id, requestOptions, signal);





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof getApiDeviceIdEmergencyContact>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetApiDeviceIdEmergencyContactInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof getApiDeviceIdEmergencyContact>>>
export type GetApiDeviceIdEmergencyContactInfiniteQueryError = ProblemDetails


export function useGetApiDeviceIdEmergencyContactInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getApiDeviceIdEmergencyContact>>>, TError = ProblemDetails>(
 id: string, options: { query:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getApiDeviceIdEmergencyContact>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiDeviceIdEmergencyContact>>,
          TError,
          Awaited<ReturnType<typeof getApiDeviceIdEmergencyContact>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiDeviceIdEmergencyContactInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getApiDeviceIdEmergencyContact>>>, TError = ProblemDetails>(
 id: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getApiDeviceIdEmergencyContact>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiDeviceIdEmergencyContact>>,
          TError,
          Awaited<ReturnType<typeof getApiDeviceIdEmergencyContact>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiDeviceIdEmergencyContactInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getApiDeviceIdEmergencyContact>>>, TError = ProblemDetails>(
 id: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getApiDeviceIdEmergencyContact>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetApiDeviceIdEmergencyContactInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getApiDeviceIdEmergencyContact>>>, TError = ProblemDetails>(
 id: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getApiDeviceIdEmergencyContact>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetApiDeviceIdEmergencyContactInfiniteQueryOptions(id,options)

  const query = useInfiniteQuery(queryOptions, queryClient) as  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getGetApiDeviceIdEmergencyContactQueryOptions = <TData = Awaited<ReturnType<typeof getApiDeviceIdEmergencyContact>>, TError = ProblemDetails>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiDeviceIdEmergencyContact>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiDeviceIdEmergencyContactQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiDeviceIdEmergencyContact>>> = ({ signal }) => getApiDeviceIdEmergencyContact(id, requestOptions, signal);





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiDeviceIdEmergencyContact>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetApiDeviceIdEmergencyContactQueryResult = NonNullable<Awaited<ReturnType<typeof getApiDeviceIdEmergencyContact>>>
export type GetApiDeviceIdEmergencyContactQueryError = ProblemDetails


export function useGetApiDeviceIdEmergencyContact<TData = Awaited<ReturnType<typeof getApiDeviceIdEmergencyContact>>, TError = ProblemDetails>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiDeviceIdEmergencyContact>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiDeviceIdEmergencyContact>>,
          TError,
          Awaited<ReturnType<typeof getApiDeviceIdEmergencyContact>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiDeviceIdEmergencyContact<TData = Awaited<ReturnType<typeof getApiDeviceIdEmergencyContact>>, TError = ProblemDetails>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiDeviceIdEmergencyContact>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiDeviceIdEmergencyContact>>,
          TError,
          Awaited<ReturnType<typeof getApiDeviceIdEmergencyContact>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiDeviceIdEmergencyContact<TData = Awaited<ReturnType<typeof getApiDeviceIdEmergencyContact>>, TError = ProblemDetails>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiDeviceIdEmergencyContact>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetApiDeviceIdEmergencyContact<TData = Awaited<ReturnType<typeof getApiDeviceIdEmergencyContact>>, TError = ProblemDetails>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiDeviceIdEmergencyContact>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetApiDeviceIdEmergencyContactQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const postApiDeviceDeviceIdMode = (
    deviceId: string,
    setDeviceModeRequest?: SetDeviceModeRequest,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<DeviceModeResponse>(
      {url: `/api/Device/${deviceId}/mode`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: setDeviceModeRequest, signal
    },
      options);
    }




export const getPostApiDeviceDeviceIdModeMutationOptions = <TError = unknown | null,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiDeviceDeviceIdMode>>, TError,{deviceId: string;data?: SetDeviceModeRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof postApiDeviceDeviceIdMode>>, TError,{deviceId: string;data?: SetDeviceModeRequest}, TContext> => {

const mutationKey = ['postApiDeviceDeviceIdMode'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postApiDeviceDeviceIdMode>>, {deviceId: string;data?: SetDeviceModeRequest}> = (props) => {
          const {deviceId,data} = props ?? {};

          return  postApiDeviceDeviceIdMode(deviceId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PostApiDeviceDeviceIdModeMutationResult = NonNullable<Awaited<ReturnType<typeof postApiDeviceDeviceIdMode>>>
    export type PostApiDeviceDeviceIdModeMutationBody = SetDeviceModeRequest | undefined
    export type PostApiDeviceDeviceIdModeMutationError = unknown | null

    export const usePostApiDeviceDeviceIdMode = <TError = unknown | null,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiDeviceDeviceIdMode>>, TError,{deviceId: string;data?: SetDeviceModeRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postApiDeviceDeviceIdMode>>,
        TError,
        {deviceId: string;data?: SetDeviceModeRequest},
        TContext
      > => {
      return useMutation(getPostApiDeviceDeviceIdModeMutationOptions(options), queryClient);
    }
    export const getApiDeviceDeviceIdMode = (
    deviceId: string,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<DeviceModeResponse>(
      {url: `/api/Device/${deviceId}/mode`, method: 'GET', signal
    },
      options);
    }




export const getGetApiDeviceDeviceIdModeInfiniteQueryKey = (deviceId: string,) => {
    return [
    'infinite', `/api/Device/${deviceId}/mode`
    ] as const;
    }

export const getGetApiDeviceDeviceIdModeQueryKey = (deviceId: string,) => {
    return [
    `/api/Device/${deviceId}/mode`
    ] as const;
    }


export const getGetApiDeviceDeviceIdModeInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof getApiDeviceDeviceIdMode>>>, TError = unknown | null>(deviceId: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getApiDeviceDeviceIdMode>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiDeviceDeviceIdModeInfiniteQueryKey(deviceId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiDeviceDeviceIdMode>>> = ({ signal }) => getApiDeviceDeviceIdMode(deviceId, requestOptions, signal);





   return  { queryKey, queryFn, enabled: deviceId !== null && deviceId !== undefined, ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof getApiDeviceDeviceIdMode>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetApiDeviceDeviceIdModeInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof getApiDeviceDeviceIdMode>>>
export type GetApiDeviceDeviceIdModeInfiniteQueryError = unknown | null


export function useGetApiDeviceDeviceIdModeInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getApiDeviceDeviceIdMode>>>, TError = unknown | null>(
 deviceId: string, options: { query:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getApiDeviceDeviceIdMode>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiDeviceDeviceIdMode>>,
          TError,
          Awaited<ReturnType<typeof getApiDeviceDeviceIdMode>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiDeviceDeviceIdModeInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getApiDeviceDeviceIdMode>>>, TError = unknown | null>(
 deviceId: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getApiDeviceDeviceIdMode>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiDeviceDeviceIdMode>>,
          TError,
          Awaited<ReturnType<typeof getApiDeviceDeviceIdMode>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiDeviceDeviceIdModeInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getApiDeviceDeviceIdMode>>>, TError = unknown | null>(
 deviceId: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getApiDeviceDeviceIdMode>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetApiDeviceDeviceIdModeInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getApiDeviceDeviceIdMode>>>, TError = unknown | null>(
 deviceId: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getApiDeviceDeviceIdMode>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetApiDeviceDeviceIdModeInfiniteQueryOptions(deviceId,options)

  const query = useInfiniteQuery(queryOptions, queryClient) as  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getGetApiDeviceDeviceIdModeQueryOptions = <TData = Awaited<ReturnType<typeof getApiDeviceDeviceIdMode>>, TError = unknown | null>(deviceId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiDeviceDeviceIdMode>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiDeviceDeviceIdModeQueryKey(deviceId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiDeviceDeviceIdMode>>> = ({ signal }) => getApiDeviceDeviceIdMode(deviceId, requestOptions, signal);





   return  { queryKey, queryFn, enabled: deviceId !== null && deviceId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiDeviceDeviceIdMode>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetApiDeviceDeviceIdModeQueryResult = NonNullable<Awaited<ReturnType<typeof getApiDeviceDeviceIdMode>>>
export type GetApiDeviceDeviceIdModeQueryError = unknown | null


export function useGetApiDeviceDeviceIdMode<TData = Awaited<ReturnType<typeof getApiDeviceDeviceIdMode>>, TError = unknown | null>(
 deviceId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiDeviceDeviceIdMode>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiDeviceDeviceIdMode>>,
          TError,
          Awaited<ReturnType<typeof getApiDeviceDeviceIdMode>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiDeviceDeviceIdMode<TData = Awaited<ReturnType<typeof getApiDeviceDeviceIdMode>>, TError = unknown | null>(
 deviceId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiDeviceDeviceIdMode>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiDeviceDeviceIdMode>>,
          TError,
          Awaited<ReturnType<typeof getApiDeviceDeviceIdMode>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiDeviceDeviceIdMode<TData = Awaited<ReturnType<typeof getApiDeviceDeviceIdMode>>, TError = unknown | null>(
 deviceId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiDeviceDeviceIdMode>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetApiDeviceDeviceIdMode<TData = Awaited<ReturnType<typeof getApiDeviceDeviceIdMode>>, TError = unknown | null>(
 deviceId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiDeviceDeviceIdMode>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetApiDeviceDeviceIdModeQueryOptions(deviceId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






